import Cookies from "js-cookie";
import { useQuery } from "@tanstack/react-query";
import { useMemo } from "react";
import { getAllEmployeesQueryOptions } from "@/config/queries/query-options";
import { DataTable } from "./_components/employees-table/data-table";
import { columns } from "./_components/employees-table/columns";
import { QueryError } from "@/components/query-error";

const TodosProgressOfEmployees = () => {
  const user = Cookies.get("key") as string;

  const { data, isPending, isFetching, isError, error, refetch } = useQuery(
    getAllEmployeesQueryOptions(user)
  );

  const employeesData = useMemo(() => {
    if (isPending || isFetching) {
      return [];
    }

    if (data === undefined || data?.employees === undefined) {
      return [];
    }

    const result = data?.employees?.map((emp) => {
      return {
        id: emp?._id,
        name: emp?.name,
        email: emp?.email,
        phone: emp?.phone,
      };
    });

    return result;
  }, [data, isPending, isFetching]);

  return (
    <div className="p-5 h-[calc(100%-56px)]">
      <div className="flex items-center justify-between">
        <h3 className="text-2xl font-medium">Todos Progress</h3>
      </div>

      {isPending ? (
        <div>Loading</div>
      ) : isError ? (
        <QueryError what="employees" error={error} onRetry={refetch} />
      ) : data?.employees?.length ? (
        <div className="mt-5">
          <DataTable data={employeesData} columns={columns} />
        </div>
      ) : (
        <div>No Employees</div>
      )}
    </div>
  );
};

export default TodosProgressOfEmployees;
